import type { StorageKey } from "./storage.keys";
import { notifyStorageStore } from "./storage.store";

export { keys, type StorageKey } from "./storage.keys";

export class StorageUtils {
  /* Local storage */

  public static getItem(key: StorageKey): string | null {
    return localStorage.getItem(key);
  }

  public static setItem(key: StorageKey, value: string): void {
    localStorage.setItem(key, value);
    notifyStorageStore();
  }

  public static removeItem(key: StorageKey): void {
    localStorage.removeItem(key);
    notifyStorageStore();
  }

  public static clear(): void {
    localStorage.clear();
    notifyStorageStore();
  }

  /* Session storage */

  public static getSessionItem(key: StorageKey): string | null {
    return sessionStorage.getItem(key);
  }

  public static setSessionItem(key: StorageKey, value: string): void {
    sessionStorage.setItem(key, value);
    notifyStorageStore();
  }

  public static removeSessionItem(key: StorageKey): void {
    sessionStorage.removeItem(key);
    notifyStorageStore();
  }

  public static clearSession(): void {
    sessionStorage.clear();
    notifyStorageStore();
  }
}
